
import wx from 'weixin-js-sdk'
import { getConfig, addFile } from '@/api/wx.js'
import addressPicker from './address.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import { declare, getAreaType, getDetail, modify } from '@/api/zhigongxiaojia'
import { lazyAMapApiLoaderInstance, AMapManager } from 'vue-amap'
import markerIcon from '../../assets/zhigongxiaojia/dingwei@3x.png'
import config from '@/config/index'
let amapManager = new AMapManager()
export default {
directives: {
TransferDom
},
name: 'declare',
components: {
Cell,
Group,
XInput,
GroupTitle,
XTextarea,
XButton,
Selector,
Popup,
addressPicker
},
data () {
return {
baseUrl: config.baseUrl,
zoom: 12,
amapManager,
mapCenter: [120.15417, 30.183178],
map: null,
overlays: [],
markers: [], // 默认点
showMap: false,
areatypeList: [],
addressValue: [],
shenbaoObj: {
unitname: '',
areatype: this.$store.state.user.workerObj.areatype,
provinceid: '',
cityid: '',
countyid: '',
unitstaffnum: '',
homename: '',
homeaddress: '',
longitude: '',
latitude: '',
telphone: '',
homearea: '',
homefacilities: '',
homeimgs: '',
homevideo: '',
homeintroduce: '',
externallinks: '',
accountid: this.$store.state.user.accountid,
sourcetype: 1,
hallnum: '', // 职工小食堂 数量
gasnum: '', // 煤气灶
stirnum: '', // 炒菜机
stovenum: '', // 电磁炉
ricenum: '', // 电饭煲
fridgesnum: '', // 冰箱
cabinetnum: '', // 消毒柜
airnum: '', // 空调
bathroomnum: '', // 卫生间
showernum: '', // 淋浴房
lavatory: '', // 盥洗室
bed: '', // 床
booksnum: '', // 小书屋
fitnessnum: '', // 健身
vgardennum: '', // 小菜园数量
vgardenarea: '', // 小菜园占地面积
vegetabletype: '', // 蔬菜品种
fgardennum: '', // 小花园数量
fgardenarea: '', // 小花园数量
flowerstype: '' 
},
photoObj: {
imgcount: 5,
imglist: [],
fileUrlArr: []
},
sourcetype: 1,
id: this.$route.params.id,
events: {
init: (o) => {
this.$refs.map.$amap.setFitView()
}
},
searchOption: {
city: '杭州市',
citylimit: true
},
show_facil: false,
facil: [],
facil_name: [],
facil_detail1: false,
facil_detail2: false,
facil_detail3: false,
facil_detail4: false,
facil_detail5: false
}
},
computed: {
accountid () {
return this.$store.state.user.accountid
}
},
mounted () {
this.wxconfig()
this.getLocation()
if (this.id) {

this.getDetail(this.getAreaType)
} else { // 新增申报
this.getAreaType()
}
let _this = this
lazyAMapApiLoaderInstance.load().then(() => {
_this.map = amapManager.getMap()
let mouseTool = new AMap.MouseTool(_this.map)

mouseTool.on('draw', function (e) {
_this.markers = []



if (_this.overlays.length > 0) {
_this.map.remove(_this.overlays)
_this.overlays = []
}
_this.overlays.push(e.obj)
_this.shenbaoObj.longitude = e.obj.getPosition().lng
_this.shenbaoObj.latitude = e.obj.getPosition().lat
})
mouseTool.marker({

content: `<div style="z-index:9999"><img src="${markerIcon}" width="35"></div>`
})
})
},
methods: {

getDetail (fn) {
getDetail({
accountid: this.accountid,
sourcetype: this.sourcetype,
id: this.id
}).then(res => {
let obj = res.returnValue
this.shenbaoObj = {
id: this.id,
unitname: obj.unitname,
areatype: obj.areatype,
provinceid: obj.provinceid,
cityid: obj.cityid,
countyid: obj.countyid,
unitstaffnum: obj.unitstaffnum,
homename: obj.homename,
homeaddress: obj.homeaddress,
longitude: obj.longitude,
latitude: obj.latitude,
telphone: obj.telphone,
homearea: obj.homearea,
homefacilities: obj.homefacilities,
homeimgs: obj.homeimgs,
homevideo: obj.homevideo,
homeintroduce: obj.homeintroduce,
externallinks: obj.externallinks,
accountid: this.$store.state.user.accountid,
sourcetype: 1,
hallnum: obj.hallnum, // 职工小食堂 数量
gasnum: obj.gasnum, // 煤气灶
stirnum: obj.stirnum, // 炒菜机
stovenum: obj.stovenum, // 电磁炉
ricenum: obj.ricenum, // 电饭煲
fridgesnum: obj.fridgesnum, // 冰箱
cabinetnum: obj.cabinetnum, // 消毒柜
airnum: obj.airnum, // 空调
bathroomnum: obj.bathroomnum, // 卫生间
showernum: obj.showernum, // 淋浴房
lavatory: obj.lavatory, // 盥洗室
bed: obj.bed, // 床
booksnum: obj.booksnum, // 小书屋
fitnessnum: obj.fitnessnum, // 健身
vgardennum: obj.vgardennum, // 小菜园数量
vgardenarea: obj.vgardenarea, // 小菜园占地面积
vegetabletype: obj.vegetabletype, // 蔬菜品种
fgardennum: obj.fgardennum, // 小花园数量
fgardenarea: obj.fgardenarea, // 小花园数量
flowerstype: obj.flowerstype 
}
this.photoObj.imglist = obj.homeimgsFile
this.photoObj.fileUrlArr = []
obj.homeimgsFile.forEach(el => {
this.photoObj.fileUrlArr.push(el.filepath)
})
console.log(this.photoObj.fileUrlArr)
this.addressValue = [
obj.provinceid.toString(),
obj.cityid.toString(),
obj.countyid.toString()
]
let arr = [this.shenbaoObj.longitude, this.shenbaoObj.latitude]
this.center = arr 
this.markers = [

{
position: arr,
content: `<div style="z-index:9999"><img src="${markerIcon}" width="35"></div>`
}
]
if (fn) fn()
})
},

getAreaType () {
let areatype = this.shenbaoObj.areatype
getAreaType().then(res => {
this.areatypeList = res.obj.filter(item => {
if (areatype === '4') {

return item.key === '4'
} else if (areatype === '5') {

return item.key === '5'
} else if (parseInt(item.key) >= parseInt(areatype)) {
return parseInt(item.key) >= parseInt(areatype)
}
})
})
},
submit () {
this.shenbaoObj.provinceid = this.addressValue[0] || ''
this.shenbaoObj.cityid = this.addressValue[1] || ''
this.shenbaoObj.countyid = this.addressValue[2] || ''

let arr = this.photoObj.imglist.map(item => item.id)
this.shenbaoObj.homeimgs = arr.join(';')
if (this.shenbaoObj.unitname === '') {
this.$vux.toast.text('请先填写单位名称')
return false
}
if (this.shenbaoObj.areatype === '') {
this.$vux.toast.text('请先选择地区级别')
return false
}
if (this.shenbaoObj.areatype === '1' && this.shenbaoObj.provinceid === '') {
this.$vux.toast.text('请先选择所在地区')
return false
} else if ((this.shenbaoObj.areatype === '3' || this.level === '4') && this.shenbaoObj.cityid === '') {
this.$vux.toast.text('请先选择所在地区')
return false
} else if (this.shenbaoObj.areatype === '5' && this.shenbaoObj.countyid === '') {
this.$vux.toast.text('请先选择所在地区')
return false
}
if (this.shenbaoObj.unitstaffnum === '') {
this.$vux.toast.text('请先填写单位职工数')
return false
}
if (this.shenbaoObj.telphone === '') {
this.$vux.toast.text('请先填写联系电话')
return false
}
if (this.shenbaoObj.homename === '') {
this.$vux.toast.text('请先填写小家名称')
return false
}
if (this.shenbaoObj.homeaddress === '') {
this.$vux.toast.text('请先填写小家地址')
return false
}
if (this.shenbaoObj.longitude === '' || this.shenbaoObj.latitude === '') {
this.$vux.toast.text('请在地图上标注小家地址')
return false
}
if (this.shenbaoObj.homearea === '') {
this.$vux.toast.text('请先填写小家面积')
return false
}
if (this.facil.length === 0) {
this.$vux.toast.text('请先填写小家设施')
return false
}
if (this.facil_detail1) {
if (this.shenbaoObj.hallnum === '' ||
this.shenbaoObj.gasnum === '' ||
this.shenbaoObj.stirnum === '' ||
this.shenbaoObj.stovenum === '' ||
this.shenbaoObj.ricenum === '' ||
this.shenbaoObj.fridgesnum === '' ||
this.shenbaoObj.cabinetnum === '' ||
this.shenbaoObj.airnum === '') {
this.$vux.toast.text('请填写完整职工小食堂')
return false
}
}
if (this.facil_detail2) {
if (this.shenbaoObj.bathroomnum === '' ||
this.shenbaoObj.showernum === '' ||
this.shenbaoObj.lavatory === '') {
this.$vux.toast.text('请填写完整卫浴设施')
return false
}
}
if (this.facil_detail3) {
if (this.shenbaoObj.bed === '' ||
this.shenbaoObj.booksnum === '' ||
this.shenbaoObj.fitnessnum === '') {
this.$vux.toast.text('请填写完整休闲娱乐设施')
return false
}
}
if (this.facil_detail4) {
if (this.shenbaoObj.vgardennum === '' ||
this.shenbaoObj.vgardenarea === '' ||
this.shenbaoObj.vegetabletype === '') {
this.$vux.toast.text('请填写完整职工小菜园')
return false
}
}
if (this.facil_detail5) {
if (this.shenbaoObj.fgardennum === '' ||
this.shenbaoObj.fgardenarea === '' ||
this.shenbaoObj.flowerstype === '') {
this.$vux.toast.text('请填写完整职工小花园')
return false
}
}
if (this.shenbaoObj.homeintroduce === '') {
this.$vux.toast.text('请先填写小家介绍')
return false
}
if (this.shenbaoObj.homeimgs === '') {
this.$vux.toast.text('请先上传图片')
return false
}
let _this = this
if (this.id) {

modify(this.shenbaoObj).then(res => {
this.$vux.alert.show({
content: '修改成功',
onHide () {
_this.$router.go(-1)
}
})
})
} else {
declare(this.shenbaoObj).then(res => {
this.$vux.alert.show({
content: '提交成功',
onHide () {
_this.$router.replace({
name: 'zhigongxiaojiaWorkspaceDealList'
})
}
})
})
}
},
mapSubmit () {
if (this.shenbaoObj.longitude === '' || this.shenbaoObj.latitude === '') {
this.$vux.toast.text('请在地图上标注小家地址')
return false
}
this.showMap = false
},

onClick () {
this.showMap = true
},

wxconfig () {
let ua = window.navigator.userAgent.toLowerCase()

let href = window.location.href.split('#')[0]
if (
ua.match(/MicroMessenger/i) == 'micromessenger' &&
ua.match(/wxwork/i) == 'wxwork'
) {
href = window.location.href.split('#')[0]

} else if (ua.match(/micromessenger/i) == 'micromessenger') {
href = this.$store.state.user.wechatSignUrl

}
getConfig({
url: href
}).then(re => {
var configs = re.returnValue
wx.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: configs.appId, // 必填，公众号的唯一标识
timestamp: configs.timestamp, // 必填，生成签名的时间戳
nonceStr: configs.nonceStr, // 必填，生成签名的随机串
signature: configs.signature, // 必填，签名，见附录1
jsApiList: ['chooseImage', 'uploadImage', 'previewImage', 'getLocation'] 
})
})
},

chooseFile (imglist, imgcount) {
let count = imgcount - imglist.length

var _this = this
wx.chooseImage({
count: count, // 默认9
sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
success: res => {
var localIds = res.localIds
_this.index = 0
if (localIds.length > 0) {
_this.uploadFile(imglist, localIds)
}
}
})
},

uploadFile (imglist, localIds) {
var _this = this
if (_this.index >= localIds.length) {
return
}
wx.uploadImage({
localId: localIds[_this.index], // 需要上传的图片的本地ID，由chooseFile接口获得
success: res => {
addFile({
mediaId: res.serverId
}).then(re => {
imglist.push(re.returnValue)
_this.photoObj.fileUrlArr.push(re.returnValue.filepath)
_this.index++
_this.uploadFile(imglist, localIds)
})
}
})
},

preview (index, fileList) {
let arr = fileList.map(item => this.baseUrl + item)
wx.previewImage({
current: arr[index], // 当前显示图片的http链接
urls: arr 
})
},
del (index) {
this.photoObj.imglist.splice(index, 1)
},
getLocation () {
wx.ready(() => {
wx.getLocation({
type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
success: (res) => {
this.mapCenter = [res.longitude, res.latitude]
let geocoder = new AMap.Geocoder({
city: ''
})
geocoder.getAddress(this.mapCenter, (status, result) => {
if (status === 'complete' && result.info === 'OK') {
var city = result.regeocode.addressComponent.city
this.searchOption.city = city
}
})
}
})
})
},
onSearchResult (pois) {
let latSum = 0
let lngSum = 0
this.markers = []
if (pois.length > 0) {
pois.forEach(poi => {
let { lng, lat } = poi
lngSum += lng
latSum += lat
this.markers.push({
position: [poi.lng, poi.lat],
content: `<div style="z-index:9999"><img src="${markerIcon}" width="35"></div>`
})
})
let center = {
lng: lngSum / pois.length,
lat: latSum / pois.length
}
this.mapCenter = [center.lng, center.lat]
}
},
get_facil () {
this.show_facil = true
},
cancel () {
this.show_facil = false
},
confirm () {

this.show_facil = false
this.facil_detail1 = false
this.facil_detail2 = false
this.facil_detail3 = false
this.facil_detail4 = false
this.facil_detail5 = false

this.facil.sort()
for (var i in this.facil) {

if (this.facil[i] === '1') {
this.facil_name.push('职工小食堂')
this.facil_detail1 = true
}
if (this.facil[i] === '2') {
this.facil_name.push('卫浴设施')
this.facil_detail2 = true
}
if (this.facil[i] === '3') {
this.facil_name.push('休闲娱乐设施')
this.facil_detail3 = true
}
if (this.facil[i] === '4') {
this.facil_name.push('职工小菜园')
this.facil_detail4 = true
}
if (this.facil[i] === '5') {
this.facil_name.push('职工小花园')
this.facil_detail5 = true
}
}


if (this.facil.indexOf('1') === -1) {
this.shenbaoObj.hallnum = this.shenbaoObj.gasnum = this.shenbaoObj.stirnum = this.shenbaoObj.stovenum = this.shenbaoObj.ricenum = this.shenbaoObj.fridgesnum = this.shenbaoObj.cabinetnum = this.shenbaoObj.airnum = ''
}
if (this.facil.indexOf('2') === -1) {
this.shenbaoObj.bathroomnum = this.shenbaoObj.showernum = this.shenbaoObj.lavatory = ''
}
if (this.facil.indexOf('3') === -1) {
this.shenbaoObj.bed = this.shenbaoObj.booksnum = this.shenbaoObj.fitnessnum = ''
}
if (this.facil.indexOf('4') === -1) {
this.shenbaoObj.vgardennum = this.shenbaoObj.vgardenarea = this.shenbaoObj.vegetabletype = ''
}
if (this.facil.indexOf('5') === -1) {
this.shenbaoObj.fgardennum = this.shenbaoObj.fgardenarea = this.shenbaoObj.flowerstype = ''
}
var testdiv = document.getElementById('select_auth')
testdiv.innerHTML = this.facil_name.join('、')
this.facil_name.length = 0
}
}
}
